import { render } from "./Servicios.vue?vue&type=template&id=d10b77e2&ts=true"
import script from "./Servicios.vue?vue&type=script&lang=ts"
export * from "./Servicios.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__